import { BRAND } from "../config/brand";
import React from "react";
import { Check } from "lucide-react";

const WA_NUMBER = BRAND.whatsappNumber;

const PLANS = [
  {
    id: "mensal",
    name: "Mensal",
    badge: "1 mês",
    price: "25",
    period: "/mês",
    description:
      "Acesso completo a canais, filmes e séries. Sem fidelidade, cancele quando quiser.",
    highlight: false,
    cta: "ASSINAR PLANO MENSAL",
    waMessage:
      "Olá! Quero contratar o *Plano MENSAL* da MasterX HD por R$ 25,00 (pagamento via PIX).",
  },
  {
    id: "trimestral",
    name: "Trimestral",
    badge: "3 meses",
    price: "60",
    period: "/3 meses",
    description:
      "3 meses de acesso completo com economia de mais de 20% em relação ao mensal.",
    highlight: true,
    cta: "ASSINAR PLANO TRIMESTRAL",
    waMessage:
      "Olá! Quero contratar o *Plano TRIMESTRAL* da MasterX HD por R$ 60,00 (pagamento via PIX).",
  },
  {
    id: "semestral",
    name: "Semestral",
    badge: "6 meses",
    price: "120",
    period: "/6 meses",
    description:
      "6 meses pelo melhor preço — o melhor custo-benefício da MasterX HD.",
    highlight: false,
    cta: "ASSINAR PLANO SEMESTRAL",
    waMessage:
      "Olá! Quero contratar o *Plano SEMESTRAL* da MasterX HD por R$ 120,00 (pagamento via PIX).",
  },
];

const FEATURES = [
  "Canais ao vivo, filmes e séries em Full HD",
  "Esportes ao vivo em todas as plataformas",
  "1 tela",
  "Liberação após confirmação do pagamento",
];

export default function PlansSection() {
  return (
    <section
      id="planos"
      data-testid="plans-section"
      className="max-w-[1500px] mx-auto px-6 mt-20"
    >
      <div className="text-center">
        <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight">
          Escolha seu <span className="text-brand-light">plano</span>
        </h2>
        <p className="text-white/60 mt-3 max-w-2xl mx-auto">
          Pagamento exclusivamente via <span className="font-semibold text-white/90">PIX</span>, com liberação rápida após a confirmação.
        </p>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {PLANS.map((plan) => {
          const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(plan.waMessage)}`;
          return (
            <div
              key={plan.id}
              data-testid={`plan-card-${plan.id}`}
              className={`relative rounded-2xl border p-7 flex flex-col bg-gradient-to-br from-surface to-surface transition ${
                plan.highlight
                  ? "border-brand/60 shadow-2xl shadow-brand/20 md:-translate-y-2"
                  : "border-white/10 hover:border-white/20"
              }`}
            >
              {plan.highlight && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-brand text-white text-[10px] font-bold uppercase tracking-widest shadow-lg">
                  Mais vendido
                </div>
              )}

              <div className="flex items-center justify-between">
                <h3 className="text-2xl font-extrabold text-white">
                  {plan.name}
                </h3>
                <span className="px-2.5 py-1 rounded-full bg-brand/15 border border-brand/40 text-brand-light text-[11px] font-semibold">
                  {plan.badge}
                </span>
              </div>

              <p className="text-sm text-white/60 mt-3 leading-relaxed">
                {plan.description}
              </p>

              <div className="mt-6 flex items-end gap-1">
                <span className="text-lg text-white/50 pb-2 font-semibold">R$</span>
                <span
                  data-testid={`plan-price-${plan.id}`}
                  className="text-6xl font-extrabold text-white leading-none tabular-nums"
                >
                  {plan.price}
                </span>
                <span className="text-sm text-white/50 pb-2">
                  {plan.period}
                </span>
              </div>

              <ul className="mt-6 space-y-3 flex-1">
                {FEATURES.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-white/80">
                    <Check className="w-4 h-4 text-brand-light mt-0.5 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`plan-cta-${plan.id}`}
                className={`mt-7 inline-flex items-center justify-center px-6 py-3 rounded-full font-bold text-sm tracking-wide transition ${
                  plan.highlight
                    ? "bg-brand-gradient text-white shadow-lg shadow-brand/40 hover:brightness-110"
                    : "bg-white/8 hover:bg-white/15 text-white border border-white/15"
                }`}
              >
                {plan.cta}
              </a>
            </div>
          );
        })}
      </div>

      <p className="text-center text-xs text-white/40 mt-6">
        Ao clicar em assinar, você será direcionado ao nosso WhatsApp para finalizar via PIX.
      </p>
    </section>
  );
}
